import { EQUIPMENT } from '../../../equipment/constants'
import { EXERCISE_KEY } from '../constants'
import { getValueReduxUtil } from '../../../redux/utils/get-value'
import { EXERCISES_PATH } from '../../redux'

export function getEquipmentExerciseUtil (exercise) {
  return getValueReduxUtil(exercise, EXERCISE_KEY.EQUIPMENT) ||
    [EQUIPMENT.BODYWEIGHT]
}

export function getDomainListPathExerciseUtil () {
  return EXERCISES_PATH.ALL
}

export * from './get-type'
export * from './has-no-weight'
export * from './is-activity'
export * from './is-body-weight'
export * from './get-muscles'
export * from './get-equipment'
export * from './get-secondary-muscles'
export * from './get-muscle-usage-map'
export * from './is-breathing'
export * from './is-warmup-or-stretching'
